import React, { useEffect, useRef, useState } from 'react';
import axios from '../../../axios';
import { useParams, useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';
import Editor from "@monaco-editor/react";

const ContAddQ = () => {
    const {id}=useParams()
    const navigate = useNavigate()
    const toast = useToast()
    const initialFormState = {
      
        question: '',
        options: '',
        answer: '',
        quesType: '',
        questionHin: '',
        optionsHin: '',
        answerHin: '',
    };

    const [formData, setFormData] = useState(initialFormState);
    const [product, setProduct] = useState({});
    const [bulkJson, setBulkJson] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [questionFile, setQuestionFile] = useState(null);
    const [importMessage, setImportMessage] = useState("");
    const [questionTypes, setQuestionTypes] = useState([]);
    const [isLoadingQuestionTypes, setIsLoadingQuestionTypes] = useState(true);
    const [bankQuestionType, setBankQuestionType] = useState("");
    const [bankQuestionCount, setBankQuestionCount] = useState("10");
    const [bankMessage, setBankMessage] = useState("");
    const fileInputRef = useRef(null);

    useEffect(() => {
        let active = true;
        const loadQuestionTypes = async () => {
            try {
                const { data } = await axios.get    ("getQuestionTypes");
                if (data?.success === false) throw new Error(data.message || "Unable to load question types.");
                const result = data?.result ?? data?.data ?? data;
                const types = Array.isArray(result) ? result : result?.questionTypes ?? data?.questionTypes;
                if (!Array.isArray(types) || types.some((type) => typeof type !== "string" || !type.trim())) {
                    throw new Error("Invalid question types response.");
                }
                if (!active) return;
                const values = [...new Set(types)];
                setQuestionTypes(values);
                setBankQuestionType(values[0] || "");
            } catch (error) {
                if (active) toast({ title: "Unable to load question types", description: error.response?.data?.message || error.message, status: "error", duration: 5000, position: "top", isClosable: true });
            } finally {
                if (active) setIsLoadingQuestionTypes(false);
            }
        };
        loadQuestionTypes();
        return () => { active = false; };
    }, [toast]);

    useEffect(() => {
        axios
            .get("getAllContestForAdmin")
            .then((res) => {
                if (res.data) {
                    console.log(res.data);
                    const contests = res.data?.result?.contests || res.data?.result || [];
                    const predata = contests.find((el) => el._id === id);
                    if (!predata) return;
                    console.log(predata);
                    const { _id, __v, createdOn, ...filteredPredata } = predata;

                    setProduct(filteredPredata);
                }
            })
            .catch((err) => {
                toast({
                    title: `Something Went Wrong!`,
                    status: "error",
                    duration: 4000,
                    isClosable: true,
                     position:"top"
                  });
            });
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isSubmitting || isLoadingQuestionTypes || !questionTypes.includes(formData.quesType)) return;
        setIsSubmitting(true);

        const processedFormData = {
            ...formData,
            contest: id,
            options: formData.options.split(',').map((option) => option.trim()),
            optionsHin: formData.optionsHin.split(',').map((option) => option.trim()),
        };
        console.log(processedFormData);

        axios.post(`addNewContestQuestion`, processedFormData)
            .then((res) => {
                if (res.data) {
                    toast({
                        title: `Success! Question Added successfully`,
                        status: "success",
                        duration: 4000,
                        isClosable: true,
                        position:"top"
                      });
                    navigate(-1);
                }
            })
            .catch((err) => {
                toast({
                    title: `Something Went Wrong!`,
                    status: "error",
                    duration: 4000,
                    isClosable: true,
                     position:"top"
                  });
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    const handleBulkUpload = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
        const parsed = JSON.parse(bulkJson);
        const questions = Array.isArray(parsed) ? parsed : parsed?.questions;
        if (!Array.isArray(questions) || questions.length === 0) {
            throw new Error('Enter a non-empty JSON array of questions or { "questions": [...] }.');
        }
        if (questions.some((question) => !question || typeof question !== "object" || Array.isArray(question))) {
            throw new Error("Each question must be a JSON object.");
        }

        const payload = questions.map((q) => ({
            ...q,
            contest: id
        }));

        const { data } = await axios.post("addBulkContestQuestions", {
            contest: id,
            questions: payload,
        });
        if (data?.success === false) throw new Error(data.message || "Unable to add questions.");

        toast({
            title: `${payload.length} Questions Added Successfully`,
            status: "success",
            duration: 4000,
            position: "top"
        });

        setBulkJson("");

    } catch (err) {
        console.log(err);

        toast({
            title: "Unable to add questions",
            description: err.response?.data?.message || err.message,
            status: "error",
            duration: 4000,
            position: "top"
        });
    } finally {
        setIsSubmitting(false);
    }
};

    const handleFileUpload = async () => {
        if (isSubmitting || !questionFile) return;
        setIsSubmitting(true);
        setImportMessage("");
        try {
            const payload = new FormData();
            payload.append("file", questionFile);
            payload.append("contest", id);
            const { data } = await axios.post("addBulkContestQuestions", payload, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            if (data?.success === false) throw new Error(data.message || "Question import failed.");
            const count = data?.result?.count;
            const message = count !== undefined ? `${count} questions added to this contest successfully.` : data.message || "Questions imported successfully.";
            setImportMessage(message);
            setQuestionFile(null);
            if (fileInputRef.current) fileInputRef.current.value = "";
            toast({ title: message, status: "success", duration: 4000, position: "top", isClosable: true });
        } catch (error) {
            toast({ title: "Unable to import questions", description: error.response?.data?.message || error.message, status: "error", duration: 7000, position: "top", isClosable: true });
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleAddFromBank = async (event) => {
        event.preventDefault();
        if (isSubmitting) return;
        const questionCount = Number(bankQuestionCount);
        if (!Number.isSafeInteger(questionCount) || questionCount < 1) {
            toast({ title: "Enter a positive whole number of questions.", status: "error", duration: 4000, position: "top" });
            return;
        }
        if (isLoadingQuestionTypes || !questionTypes.includes(bankQuestionType)) return;
        setIsSubmitting(true);
        setBankMessage("");
        try {
            const { data } = await axios.post("/addContestQuestionsFromBank", {
                contest: id,
                quesType: bankQuestionType,
                questionCount,
            });
            if (data?.success === false) throw new Error(data.message || "Unable to add questions from the question bank.");
            const message = data?.message || "Questions added to this contest from the question bank successfully.";
            setBankMessage(message);
            toast({ title: message, status: "success", duration: 4000, position: "top", isClosable: true });
        } catch (error) {
            toast({ title: "Unable to add questions from bank", description: error.response?.data?.message || error.message, status: "error", duration: 6000, position: "top", isClosable: true });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="m-6 py-8">
            <form onSubmit={handleAddFromBank} aria-label="Add questions from bank" className="mb-6 rounded-lg bg-white p-5 shadow">
                <h2 className="mb-3 text-lg font-bold">Add Questions from Question Bank</h2>
                <p className="mb-4 text-sm text-gray-600">Choose a question type and count to add questions to {product.contestName || "this contest"}.</p>
                <div className="flex flex-wrap items-end gap-4">
                    <div>
                        <label htmlFor="bank-question-type" className="mb-2 block text-sm font-medium text-gray-700">Question Type</label>
                        <select id="bank-question-type" value={bankQuestionType} disabled={isSubmitting || isLoadingQuestionTypes || !questionTypes.length} onChange={(event) => { setBankQuestionType(event.target.value); setBankMessage(""); }} className="rounded border px-3 py-2">
                            <option value="" disabled>{isLoadingQuestionTypes ? "Loading question types..." : "Select question type"}</option>
                            {questionTypes.map((type) => <option key={type} value={type}>{type.toUpperCase()}</option>)}
                        </select>
                    </div>
                    <div>
                        <label htmlFor="bank-question-count" className="mb-2 block text-sm font-medium text-gray-700">Number of Questions</label>
                        <input id="bank-question-count" type="number" min="1" step="1" required value={bankQuestionCount} disabled={isSubmitting} onChange={(event) => { setBankQuestionCount(event.target.value); setBankMessage(""); }} className="w-44 rounded border px-3 py-2" />
                    </div>
                    <button type="submit" disabled={isSubmitting || isLoadingQuestionTypes || !questionTypes.length} className="rounded bg-purple px-5 py-2 text-white disabled:cursor-not-allowed disabled:opacity-50">Add from Question Bank</button>
                </div>
                {bankMessage && <p role="status" className="mt-3 text-sm font-medium text-green-700">{bankMessage}</p>}
            </form>
    
            <div className="bg-white shadow rounded-lg p-5 mb-6">

    <h2 className="text-lg font-bold mb-3">
        Bulk Upload Questions (JSON)
    </h2>

    {/* <textarea
        rows={15}
        value={bulkJson}
        onChange={(e)=>setBulkJson(e.target.value)}
        placeholder="Paste JSON Array Here..."
        className="w-full border rounded-md p-3"
    /> */}
    
<Editor
    height="500px"
    defaultLanguage="json"
    theme="vs-dark"
    value={bulkJson}
    onChange={(value) => setBulkJson(value || "")}
/>

    <button
        type="button"
        onClick={handleBulkUpload}
        disabled={isSubmitting}
        className="mt-4 bg-green-600 text-white px-5 py-2 rounded disabled:cursor-not-allowed disabled:opacity-50"
    >
        Upload Questions
    </button>

</div>
            <form onSubmit={handleSubmit}>
                <div className="bg-white shadow rounded-lg mt-5">
                    <div className="px-4 py-5 sm:px-6">
                        <h3 className="text-xl font-bold text-purple">Add Question  ( <span className='text-bgBlue'>{product.contestName}</span>)</h3>
                    </div>
                    <div className="px-4 py-5 sm:p-6 space-y-4">
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm text-start font-medium text-gray-700">Question</label>
                                <input
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                    name="question"
                                    value={formData.question}
                                    type="text"
                                    required
                                    onChange={handleChange}
                                />
                            </div>
                            <div>
                                <label className="block text-sm text-start font-medium text-gray-700">Question (Hindi)</label>
                                <input
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                    name="questionHin"
                                    value={formData.questionHin}
                                    type="text"
                                    required
                                    onChange={handleChange}
                                />
                            </div>
                            <div>
                                <label className="block text-sm text-start font-medium text-gray-700">Options (comma separated)</label>
                                <input
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                    name="options"
                                    value={formData.options}
                                    type="text"
                                    required
                                    onChange={handleChange}
                                />
                            </div>
                            <div>
                                <label className="block text-sm text-start font-medium text-gray-700">Options (Hindi, comma separated)</label>
                                <input
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                    name="optionsHin"
                                    value={formData.optionsHin}
                                    type="text"
                                    required
                                    onChange={handleChange}
                                />
                            </div>
                            <div>
                                <label className="block text-sm text-start font-medium text-gray-700">Answer</label>
                                <input
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                    name="answer"
                                    value={formData.answer}
                                    type="text"
                                    required
                                    onChange={handleChange}
                                />
                            </div>
                           
                           
                            <div>
                                <label className="block text-sm text-start font-medium text-gray-700">Answer (Hindi)</label>
                                <input
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                    name="answerHin"
                                    value={formData.answerHin}
                                    type="text"
                                    required
                                    onChange={handleChange}
                                />
                            </div>
                            <div>
                                <label htmlFor="contest-question-type" className="block text-sm text-start font-medium text-gray-700">Question Type</label>
                                <select
                                    id="contest-question-type"
                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                                    name="quesType"
                                    disabled={isSubmitting || isLoadingQuestionTypes || !questionTypes.length}
                                    value={formData.quesType}
                                    required
                                    onChange={handleChange}
                                >
                                    <option value="" disabled>{isLoadingQuestionTypes ? "Loading question types..." : "Select question type"}</option>
                                    {questionTypes.map((type) => <option key={type} value={type}>{type.toUpperCase()}</option>)}
                                   
                                </select>
                            </div>
                           
                        </div>
                        <div className="flex justify-end">
                            <button
                                type="submit"
                                disabled={isSubmitting || isLoadingQuestionTypes || !questionTypes.includes(formData.quesType)}
                                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-purple disabled:cursor-not-allowed disabled:opacity-70"
                            >
                                {isSubmitting ? "Submitting..." : "Submit Question"}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
            
        </div>
    );
};

export default ContAddQ;
